import { ConditionalWrap } from '@festina-life/core/src/utils/ReactUtils'
import { typographyStyles } from '@festina-life/ui/structure'
import cx from 'classnames'
import type { ReactNode } from 'react'

type Props = {
  children: ReactNode
  className?: string
  title?: string
  isFaded?: boolean
  isShowingIndicator?: boolean
  indicatorLabel?: string
}

export const Attribute = ({
  children,
  title,
  className,
  isShowingIndicator = false,
  indicatorLabel,
}: Props) => (
  <ConditionalWrap
    condition={isShowingIndicator}
    wrap={(innerChildren) => (
      <div className="relative inline-flex min-w-0 max-w-full">
        {innerChildren}
        <span
          role="status"
          aria-label={indicatorLabel}
          title={indicatorLabel}
          className="absolute top-[-1.5px] right-[-3.5px] size-1.75 rounded-full bg-warning-500 dark:bg-warning-300"
        />
      </div>
    )}
  >
    <div
      className={cx(
        `rounded-md px-1 gap-x-2 text-nowrap flex text-ellipsis overflow-hidden items-center font-medium`,
        typographyStyles({ intensity: 'secondary' }),
        {
          // Cuts a gap around the indicator out of the corner, so the gap
          // shows whatever background is behind the attribute.
          'mask-[radial-gradient(circle_at_100%_2px,transparent_5.5px,black_6px)]':
            isShowingIndicator,
        },
        className,
      )}
      title={title}
    >
      {children}
    </div>
  </ConditionalWrap>
)
